var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/auth-embedded.ts
var MISSING_CONFIG_ERROR_MESSAGE = "You must initialize this module with a getToken callback";
var getHeaders = (hostToken) => ({
  Authorization: `Bearer ${hostToken}`
});
var getBackendUser = (token, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/v1/linked-primary-partner-user`, {
    headers: getHeaders(token)
  });
  if (response.ok) {
    return (yield response.json()).data.attributes;
  }
  if (response.status === 404) {
    return void 0;
  }
  throw Error(yield response.text());
});
var createBackendUser = (token, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/v1/linked-primary-partner-users`, {
    method: "POST",
    headers: getHeaders(token)
  });
  if (response.ok) {
    return (yield response.json()).data.attributes;
  }
  throw Error(yield response.text());
});
var updateBackendUser = (token, userId, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(
    `${apiUrl}/v1/linked-primary-partner-user/${userId}`,
    {
      method: "PATCH",
      headers: getHeaders(token)
    }
  );
  if (response.status >= 400) {
    throw Error(yield response.text());
  }
});
var _leagueUser;
var EmbeddedAuthWrapper = class {
  constructor() {
    __privateAdd(this, _leagueUser, void 0);
  }
  /**
   * Get the token provided by the host app.
   */
  getToken() {
    return __async(this, null, function* () {
      throw new Error(MISSING_CONFIG_ERROR_MESSAGE);
    });
  }
  /**
   * Get the League user data object returned by the Linked Primary Partner API
   * call.
   */
  getUserId() {
    return __async(this, null, function* () {
      throw new Error(MISSING_CONFIG_ERROR_MESSAGE);
    });
  }
  initializeForMobileHandoff(config) {
    if (!config) {
      throw new Error(MISSING_CONFIG_ERROR_MESSAGE);
    }
    this.getToken = () => config.getToken();
    this.getUserId = () => config.getUserIdFromMobileHandoff();
  }
  /**
   * Initialize this module. Returns a promise which can be awaited, if desired,
   * for confirmation that initialization is complete, but it is not necessary
   * to do so before using `getToken()` or `getLeagueUser()`.
   */
  initializeForPartnerToken(config) {
    return __async(this, null, function* () {
      if (!config) {
        throw new Error(MISSING_CONFIG_ERROR_MESSAGE);
      }
      let resolveInitializationPromise;
      let rejectInitializationPromise;
      const initializationPromise = new Promise((resolve, reject) => {
        resolveInitializationPromise = resolve;
        rejectInitializationPromise = reject;
      });
      this.getToken = () => __async(this, null, function* () {
        yield initializationPromise;
        return config.getToken();
      });
      this.getUserId = () => __async(this, null, function* () {
        yield initializationPromise;
        return __privateGet(this, _leagueUser).leagueUserId;
      });
      const token = yield config.getToken();
      try {
        __privateSet(this, _leagueUser, yield getBackendUser(
          token,
          config.apiBaseUrlForLinkingPartnerToken
        ));
        if (!__privateGet(this, _leagueUser)) {
          __privateSet(this, _leagueUser, yield createBackendUser(
            token,
            config.apiBaseUrlForLinkingPartnerToken
          ));
        }
      } catch (e) {
        rejectInitializationPromise(e);
        throw e;
      }
      resolveInitializationPromise();
      yield updateBackendUser(
        token,
        __privateGet(this, _leagueUser).leagueUserId,
        config.apiBaseUrlForLinkingPartnerToken
      );
    });
  }
};
_leagueUser = new WeakMap();
var EmbeddedAuth = new EmbeddedAuthWrapper();
export {
  EmbeddedAuth
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/auth-embedded'] = window.leagueSDKsPresent['@leagueplatform/auth-embedded'] || [];
    window.leagueSDKsPresent['@leagueplatform/auth-embedded'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/auth-embedded'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/auth-embedded module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map